export const LOCAL_STORAGE_KEYS = {
  AuthToken: 'AuthToken',
  CacheClearedOn: 'CacheClearedOn',
  Projects: 'Projects',
  RefreshAuthToken: 'RefreshAuthToken',
  SelectedItemType: 'SelectedItemType',
  SelectedProject: 'SelectedProject',
};
